"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectOutcomeStakeAmount = exports.selectOrdinarErrorMessage = exports.selectOrdinarOutcomeErrorMessages = exports.selectOrdinarOutcomeError = exports.selectOrdinarOutcomeErrors = exports.selectMakeBetErrorsBottomLength = exports.selectMakeBetErrorsTopLength = exports.selectMakeBetClientErrorsBottom = exports.selectMakeBetClientErrorsTop = exports.selectMakeBetErrorsBottom = exports.selectMakeBetErrorsTop = exports.selectMakeBetClientErrors = exports.selectMakeBetErrors = exports.selectSystemSize = exports.selectSystemAmount = exports.selectExpressProperties = exports.selectOrdinarTotalAmount = exports.selectOrdinarOutcomesAmounts = exports.selectBasketOutcomesLength = exports.selectMakeBetRequestLoading = exports.selectBasketOutcomes = exports.selectBasketStatusErrors = exports.selectBasketErrors = exports.selectBasketOutcomesList = exports.getLoyaltyCouponsType = exports.getBasketLoading = exports.getBasketError = exports.getUpdateBasketOutcomesError = exports.getOutcomeKeyByOutcomeId = exports.makeSelectIsOutcomeLoading = exports.selectLoadingOutcomeKey = exports.getDeleteBasketOutcomeError = exports.getMakeBetError = exports.getBasketAppliedCouponIds = exports.getBasketConstraints = exports.getOutcomeId = exports.getEventValue = exports.getIsDependentOutcome = exports.getHighlightedDependentOutcomesList = exports.getBasketDependentEventGroups = exports.selectBasketOutcomeByKey = exports.selectBasketOutcomesMapSortedIds = exports.selectBasketOutcomesMapEntries = exports.selectBasketOutcomesMap = exports.selectClientErrors = exports.getMakeBetErrors = exports.getMakeBetRequestLoading = exports.getShowMakeBasketSuccessMessage = exports.getMakeBet = exports.getBasketMobileModal = void 0;
exports.selectCompetitorConstraintError = exports.selectIsValidBasketInput = exports.selectOrdinarValidationErrors = exports.selectBasketBalanceError = exports.selectExpressSystemValidationErrors = exports.selectCurrentBetAmount = exports.selectAvailableAmount = exports.selectIsBasketSuitableBonusCouponsShown = exports.selectLoyaltyCouponCreatedStatusLength = exports.selectBasketAppliedCoupon = exports.selectActiveLoyaltyByAppliedCouponIdsByBetType = exports.selectActiveLoyaltyWithoutAppliedCouponIdsLength = exports.selectLoyaltyCouponCreatedStatus = exports.selectActiveLoyaltyWithoutAppliedCouponIds = exports.selectActiveLoyaltyByAppliedCouponIds = exports.selectDependentEventByOutcomeId = exports.selectHighlightedDependentOutcomesListLength = exports.selectDependentEventGroupsLength = exports.selectIsDependedHighlightedOutcome = exports.selectIsDependentOutcomes = exports.selectDisabledButtonExpressSystemNew = exports.selectCanMakeComplexBet = exports.selectCanMakeOrdinarBet = exports.selectBasketOutcomesListV2 = exports.selectDisabledButtonOrdinarNew = exports.selectDisabledButtonExpressSystem = exports.selectDisabledButtonOrdinar = exports.selectIsNotActiveStatus = exports.selectDuplicateEvents = exports.selectMaxBetExpressSystem = exports.selectExpressRateWithBonus = exports.selectBonusOnExpress = exports.selectExpressRate = exports.selectExpressOutcomeValue = exports.selectOrdinarSingleAmountActive = exports.selectOrdinarSingleAmount = exports.selectBasketMakeBetStatus = exports.selectBasketBonusWallet = exports.selectBasketBetTypeTab = exports.selectBasketHeaderTab = exports.selectCountSystemCombinations = exports.selectExpressSystemLengthError = exports.selectCoefficientStatusOnChanged = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const groupBy_1 = __importDefault(require("../../utils/functions/groupBy"));
const values_1 = __importDefault(require("../../utils/functions/values"));
const isEmpty_1 = __importDefault(require("../../utils/functions/isEmpty"));
const partition_1 = __importDefault(require("../../utils/functions/partition"));
const validation_1 = require("../../domain/basket/validation");
const bonusOnExpress_1 = __importDefault(require("../../utils/bonus/bonusOnExpress"));
const basket_1 = require("../../utils/basket");
const systemCombination_1 = require("../../utils/basket/systemCombination");
const _reduxjs_1 = require("../../utils/@reduxjs");
const utils_1 = require("./utils");
const selectors_1 = require("../ConfigProvider/selectors");
const selectors_2 = require("../CommonDataProvider/selectors");
const selectors_3 = require("../PlayersProvider/selectors");
const selectors_4 = require("../AccountProvider/selectors");
const types_1 = require("../AccountProvider/types");
const constants_1 = require("../AccountProvider/constants");
const types_2 = require("./types");
const slice_1 = require("./slice");
const constants_2 = require("./constants");
const EMPTY_ERROR = [];
const getBasketMobileModal = (state) => {
    var _a;
    return (_a = state.basketProvider.layout.mobileModalType) !== null && _a !== void 0 ? _a : slice_1.initialState.layout.mobileModalType;
};
exports.getBasketMobileModal = getBasketMobileModal;
const getMakeBet = (state) => state.basketProvider.makeBetRequest || slice_1.initialState.makeBetRequest;
exports.getMakeBet = getMakeBet;
const getShowMakeBasketSuccessMessage = (state) => {
    var _a;
    return (_a = state.basketProvider.layout.isShowMakeBasketSuccessMessage) !== null && _a !== void 0 ? _a : slice_1.initialState.layout.isShowMakeBasketSuccessMessage;
};
exports.getShowMakeBasketSuccessMessage = getShowMakeBasketSuccessMessage;
const getMakeBetRequestLoading = (state) => state.basketProvider.makeBetRequest.loading ||
    slice_1.initialState.makeBetRequest.loading;
exports.getMakeBetRequestLoading = getMakeBetRequestLoading;
// export const getBasketId = (state: RootState) =>
//   state.basketProvider.basket.entry.id || initialState.basket.entry.id
const getMakeBetErrors = (state) => state.basketProvider.errors || slice_1.initialState.errors;
exports.getMakeBetErrors = getMakeBetErrors;
const selectClientErrors = (state) => state.basketProvider.clientErrors || slice_1.initialState.clientErrors;
exports.selectClientErrors = selectClientErrors;
const selectBasketOutcomesMap = (state) => state.basketProvider.basket.entry.outcomesMap ||
    slice_1.initialState.basket.entry.outcomesMap;
exports.selectBasketOutcomesMap = selectBasketOutcomesMap;
const selectBasketOutcomesMapEntries = (state) => state.basketProvider.basket.entry.outcomesMap.entries ||
    slice_1.initialState.basket.entry.outcomesMap.entries;
exports.selectBasketOutcomesMapEntries = selectBasketOutcomesMapEntries;
const selectBasketOutcomesMapSortedIds = (state) => {
    return (state.basketProvider.basket.entry.outcomesMap.sortedIds ||
        slice_1.initialState.basket.entry.outcomesMap.sortedIds);
};
exports.selectBasketOutcomesMapSortedIds = selectBasketOutcomesMapSortedIds;
const selectBasketOutcomeByKey = (state, basketOutcomeKey) => (0, exports.selectBasketOutcomesMapEntries)(state)[basketOutcomeKey];
exports.selectBasketOutcomeByKey = selectBasketOutcomeByKey;
const getBasketDependentEventGroups = (state) => state.basketProvider.basket.entry.dependentEventGroups ||
    slice_1.initialState.basket.entry.dependentEventGroups;
exports.getBasketDependentEventGroups = getBasketDependentEventGroups;
const getHighlightedDependentOutcomesList = (state) => state.basketProvider.layout.highlightedDependentOutcomesList ||
    slice_1.initialState.layout.highlightedDependentOutcomesList;
exports.getHighlightedDependentOutcomesList = getHighlightedDependentOutcomesList;
const getIsDependentOutcome = (_state, eventId) => eventId;
exports.getIsDependentOutcome = getIsDependentOutcome;
const getEventValue = (_state, eventValue) => eventValue;
exports.getEventValue = getEventValue;
const getOutcomeId = (_state, outcomeId) => outcomeId;
exports.getOutcomeId = getOutcomeId;
const getBasketConstraints = (state) => state.basketProvider.basket.constraints || slice_1.initialState.basket.constraints;
exports.getBasketConstraints = getBasketConstraints;
const getBasketAppliedCouponIds = (state) => {
    var _a;
    return (_a = state.basketProvider.basket.appliedCouponIds) !== null && _a !== void 0 ? _a : slice_1.initialState.basket.appliedCouponIds;
};
exports.getBasketAppliedCouponIds = getBasketAppliedCouponIds;
const getMakeBetError = (state) => { var _a; return (_a = state.basketProvider.makeBetRequest.error) !== null && _a !== void 0 ? _a : slice_1.initialState.makeBetRequest.error; };
exports.getMakeBetError = getMakeBetError;
const getDeleteBasketOutcomeError = (state) => {
    var _a;
    return (_a = state.basketProvider.deleteBasketOutcomeRequest.error) !== null && _a !== void 0 ? _a : slice_1.initialState.deleteBasketOutcomeRequest.error;
};
exports.getDeleteBasketOutcomeError = getDeleteBasketOutcomeError;
const selectLoadingOutcomeKey = (state) => {
    return state.basketProvider.loadingOutcomeKeys;
};
exports.selectLoadingOutcomeKey = selectLoadingOutcomeKey;
const makeSelectIsOutcomeLoading = (state, key) => {
    return !!state.basketProvider.loadingOutcomeKeys[key];
};
exports.makeSelectIsOutcomeLoading = makeSelectIsOutcomeLoading;
const getOutcomeKeyByOutcomeId = (state, outcomeId) => {
    const entries = (0, exports.selectBasketOutcomesMapEntries)(state);
    if (!outcomeId || !entries)
        return undefined;
    for (const [key, outcome] of Object.entries(entries)) {
        if (outcome.id === outcomeId) {
            return key;
        }
    }
    return undefined;
};
exports.getOutcomeKeyByOutcomeId = getOutcomeKeyByOutcomeId;
const getUpdateBasketOutcomesError = (state) => {
    var _a;
    return (_a = state.basketProvider.addToBasketRequest.error) !== null && _a !== void 0 ? _a : slice_1.initialState.addToBasketRequest.error;
};
exports.getUpdateBasketOutcomesError = getUpdateBasketOutcomesError;
const getBasketError = (state) => {
    var _a;
    return (_a = state.basketProvider.getBasketsRequest.error) !== null && _a !== void 0 ? _a : slice_1.initialState.getBasketsRequest.error;
};
exports.getBasketError = getBasketError;
const getBasketLoading = (state) => state.basketProvider.getBasketsRequest.loading ||
    slice_1.initialState.getBasketsRequest.loading;
exports.getBasketLoading = getBasketLoading;
const getLoyaltyCouponsType = (_state, type) => type;
exports.getLoyaltyCouponsType = getLoyaltyCouponsType;
exports.selectBasketOutcomesList = (0, toolkit_1.createSelector)(exports.selectBasketOutcomesMap, (basketOutcomesMap) => (0, _reduxjs_1.getValues)(basketOutcomesMap.sortedIds, (0, utils_1.basketOutcomesMapToId)(basketOutcomesMap.entries)));
exports.selectBasketErrors = (0, toolkit_1.createSelector)([
    exports.getMakeBetError,
    exports.getDeleteBasketOutcomeError,
    exports.getUpdateBasketOutcomesError,
    exports.getBasketError,
], (betError, basketError, updateBasketError, getBasketError) => [
    betError,
    basketError,
    updateBasketError,
    getBasketError,
]);
exports.selectBasketStatusErrors = (0, toolkit_1.createSelector)([exports.selectBasketErrors], (errors) => errors
    .filter((error) => !!(error === null || error === void 0 ? void 0 : error.response))
    .map((error) => { var _a; return (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status; }));
exports.selectBasketOutcomes = (0, toolkit_1.createSelector)([exports.selectBasketOutcomesList, selectors_3.selectPlayers], (outcomes, players) => (0, basket_1.getEnrichOutcomesWithPlayerNames)(outcomes, players));
const selectMakeBetRequestLoading = (state) => !!(0, exports.getMakeBetRequestLoading)(state);
exports.selectMakeBetRequestLoading = selectMakeBetRequestLoading;
exports.selectBasketOutcomesLength = (0, toolkit_1.createSelector)(exports.selectBasketOutcomesMapEntries, (basketOutcomesMapEntries) => (0, utils_1.getBasketOutcomesNumber)(basketOutcomesMapEntries));
const selectOrdinarOutcomesAmounts = (state) => state.basketProvider.ordinar.outcomesAmounts ||
    slice_1.initialState.ordinar.outcomesAmounts;
exports.selectOrdinarOutcomesAmounts = selectOrdinarOutcomesAmounts;
exports.selectOrdinarTotalAmount = (0, toolkit_1.createSelector)(exports.selectOrdinarOutcomesAmounts, (outcomesAmounts) => {
    if (!outcomesAmounts)
        return 0;
    const amounts = Object.values(outcomesAmounts);
    return amounts.reduce((sum, amount) => sum + Number(amount), 0);
});
const selectExpressProperties = (state) => state.basketProvider.express || slice_1.initialState.express;
exports.selectExpressProperties = selectExpressProperties;
const selectSystemAmount = (state) => state.basketProvider.system.amount;
exports.selectSystemAmount = selectSystemAmount;
const selectSystemSize = (state) => state.basketProvider.system.size || slice_1.initialState.system.size;
exports.selectSystemSize = selectSystemSize;
exports.selectMakeBetErrors = (0, toolkit_1.createSelector)([exports.getMakeBetErrors, selectors_1.selectConfig], (errors, config) => {
    const formErrors = (0, basket_1.getFormattedErrors)(errors, config);
    return (0, groupBy_1.default)(formErrors, 'displayType');
});
exports.selectMakeBetClientErrors = (0, toolkit_1.createSelector)([exports.selectClientErrors, selectors_1.selectConfig], (errors, config) => {
    const formErrors = (0, basket_1.getFormattedErrors)(errors, config);
    return (0, groupBy_1.default)(formErrors, 'displayType');
});
exports.selectMakeBetErrorsTop = (0, toolkit_1.createSelector)([exports.selectMakeBetErrors], (errors) => { var _a; return (_a = errors[types_2.EDisplayType.TOP]) !== null && _a !== void 0 ? _a : EMPTY_ERROR; });
exports.selectMakeBetErrorsBottom = (0, toolkit_1.createSelector)([exports.selectMakeBetErrors], (errors) => { var _a; return (_a = errors[types_2.EDisplayType.BOTTOM]) !== null && _a !== void 0 ? _a : EMPTY_ERROR; });
const selectMakeBetClientErrorsTop = (state) => { var _a; return (_a = (0, exports.selectMakeBetClientErrors)(state)[types_2.EDisplayType.TOP]) !== null && _a !== void 0 ? _a : EMPTY_ERROR; };
exports.selectMakeBetClientErrorsTop = selectMakeBetClientErrorsTop;
const selectMakeBetClientErrorsBottom = (state) => { var _a; return (_a = (0, exports.selectMakeBetClientErrors)(state)[types_2.EDisplayType.BOTTOM]) !== null && _a !== void 0 ? _a : EMPTY_ERROR; };
exports.selectMakeBetClientErrorsBottom = selectMakeBetClientErrorsBottom;
exports.selectMakeBetErrorsTopLength = (0, toolkit_1.createSelector)([exports.selectMakeBetErrorsTop], (errors) => errors.length);
exports.selectMakeBetErrorsBottomLength = (0, toolkit_1.createSelector)([exports.selectMakeBetErrorsBottom], (errors) => errors.length);
const selectOrdinarOutcomeErrors = (state) => state.basketProvider.ordinar.outcomeErrors ||
    slice_1.initialState.ordinar.outcomeErrors;
exports.selectOrdinarOutcomeErrors = selectOrdinarOutcomeErrors;
const selectOrdinarOutcomeError = (state, outcomeId) => {
    return (0, exports.selectOrdinarOutcomeErrors)(state)[outcomeId];
};
exports.selectOrdinarOutcomeError = selectOrdinarOutcomeError;
const selectOrdinarOutcomeErrorMessages = (state) => state.basketProvider.ordinar.errorMessages ||
    slice_1.initialState.ordinar.errorMessages;
exports.selectOrdinarOutcomeErrorMessages = selectOrdinarOutcomeErrorMessages;
const selectOrdinarErrorMessage = (state, outcomeId) => { var _a; return (_a = state.basketProvider.ordinar.errorMessages[outcomeId]) === null || _a === void 0 ? void 0 : _a.message; };
exports.selectOrdinarErrorMessage = selectOrdinarErrorMessage;
exports.selectOutcomeStakeAmount = (0, toolkit_1.createSelector)([exports.getOutcomeId, exports.selectOrdinarOutcomesAmounts], (outcomeId, ordinarOutcomesAmounts) => ordinarOutcomesAmounts[outcomeId]);
const selectCoefficientStatusOnChanged = (state) => state.basketProvider.layout.coefficientStatusOnChanged ||
    slice_1.initialState.layout.coefficientStatusOnChanged;
exports.selectCoefficientStatusOnChanged = selectCoefficientStatusOnChanged;
exports.selectExpressSystemLengthError = (0, toolkit_1.createSelector)(exports.getMakeBetErrors, (errors) => errors.includes(constants_2.EAllBasketErrors.EXPRESS_LENGTH) ||
    errors.includes(constants_2.EAllBasketErrors.SYSTEM_LENGTH));
const SYSTEM_COMBINATION_EMPTY_ARRAY = [];
exports.selectCountSystemCombinations = (0, _reduxjs_1.createSelectorBasedOnLength)(exports.selectBasketOutcomesList, (outcomes) => {
    if (outcomes.length <= 2) {
        return SYSTEM_COMBINATION_EMPTY_ARRAY;
    }
    return outcomes.reduce((acc, _value, index, outcomes) => {
        if (index < 2)
            return acc;
        const combinationsCount = (0, systemCombination_1.getCombinationsCount)(outcomes.length, index);
        if (combinationsCount > systemCombination_1.MAX_COMBINATION_COUNT) {
            return acc;
        }
        return [
            ...acc,
            {
                value: index,
                outcomesLength: outcomes.length,
                combinationsCount,
            },
        ];
    }, []);
});
const selectBasketHeaderTab = (state) => state.basketProvider.layout.headerTab || slice_1.initialState.layout.headerTab;
exports.selectBasketHeaderTab = selectBasketHeaderTab;
const selectBasketBetTypeTab = (state) => state.basketProvider.layout.betTypeTab || slice_1.initialState.layout.betTypeTab;
exports.selectBasketBetTypeTab = selectBasketBetTypeTab;
const selectBasketBonusWallet = (state) => state.basketProvider.layout.bonusWallet || slice_1.initialState.layout.bonusWallet;
exports.selectBasketBonusWallet = selectBasketBonusWallet;
// TODO improve logic
// TODO remove error component
exports.selectBasketMakeBetStatus = (0, toolkit_1.createSelector)([exports.getMakeBet, exports.getShowMakeBasketSuccessMessage], ({ loading, error }, isShowMakeBasketSuccessMessage) => {
    return error
        ? types_2.EMakeBetStatus.init
        : loading
            ? types_2.EMakeBetStatus.loading
            : isShowMakeBasketSuccessMessage
                ? types_2.EMakeBetStatus.success
                : types_2.EMakeBetStatus.init;
});
const selectOrdinarSingleAmount = (state) => state.basketProvider.ordinar.singleAmount;
exports.selectOrdinarSingleAmount = selectOrdinarSingleAmount;
const selectOrdinarSingleAmountActive = (state) => state.basketProvider.ordinar.singleAmountActive ||
    slice_1.initialState.ordinar.singleAmountActive;
exports.selectOrdinarSingleAmountActive = selectOrdinarSingleAmountActive;
const selectExpressOutcomeValue = (state) => state.basketProvider.express.amount;
exports.selectExpressOutcomeValue = selectExpressOutcomeValue;
exports.selectExpressRate = (0, toolkit_1.createSelector)([exports.selectBasketOutcomesList, exports.getBasketConstraints], (outcomes, constraints) => {
    var _a;
    const expressRate = outcomes.reduce((acc, { probability }) => {
        return acc * probability.odd;
    }, 1);
    const betExpressMaxCoef = (_a = constraints === null || constraints === void 0 ? void 0 : constraints.betExpressMaxCoef) !== null && _a !== void 0 ? _a : constants_2.DEFAULT_MAX_BET_EXPRESS_COEF;
    return expressRate > betExpressMaxCoef ? betExpressMaxCoef : expressRate;
});
/**
 * @description in PLAT-1038 with BONUS_ON_EXPRESS_ENABLED flag turned on
 */
const selectBasketOdds = (0, toolkit_1.createSelector)([exports.selectBasketOutcomesList], (outcomes) => outcomes.map(({ probability }) => probability.odd));
exports.selectBonusOnExpress = (0, toolkit_1.createSelector)([selectBasketOdds], (odds) => {
    return (0, bonusOnExpress_1.default)(odds);
});
/**
 * @description for not to break selectExpressRate, created new express coef calculation with bonus
 * used in PLAT-1038 with BONUS_ON_EXPRESS_ENABLED flag turned on
 */
exports.selectExpressRateWithBonus = (0, toolkit_1.createSelector)([exports.selectExpressRate, exports.selectBonusOnExpress, exports.getBasketConstraints], (expressCoef, bonusCoef, constraints) => {
    var _a;
    const betExpressMaxCoef = (_a = constraints === null || constraints === void 0 ? void 0 : constraints.betExpressMaxCoef) !== null && _a !== void 0 ? _a : constants_2.DEFAULT_MAX_BET_EXPRESS_COEF;
    const resultCoef = expressCoef * bonusCoef;
    return Math.min(resultCoef, betExpressMaxCoef);
});
exports.selectMaxBetExpressSystem = (0, toolkit_1.createSelector)(exports.selectBasketOutcomesList, (outcomes) => Math.min(...outcomes.map((outcome) => outcome.maxBet)));
exports.selectDuplicateEvents = (0, toolkit_1.createSelector)(exports.selectBasketOutcomesList, (outcomes) => {
    const allEventsId = outcomes.map(({ event }) => event.id);
    return allEventsId.filter((item, index) => index !== allEventsId.indexOf(item));
});
exports.selectIsNotActiveStatus = (0, toolkit_1.createSelector)(exports.selectBasketOutcomesList, (outcomes) => outcomes.some(({ status: outcomeStatus, event: { status: eventStatus }, probability: { tradingStatus }, }) => !constants_2.activeOutcomeStatus.includes(outcomeStatus) ||
    !constants_2.activeEventStatus.includes(eventStatus) ||
    !constants_2.activeProbabilityStatus.includes(tradingStatus)));
exports.selectDisabledButtonOrdinar = (0, toolkit_1.createSelector)([
    exports.getMakeBetErrors,
    exports.selectOrdinarOutcomeErrors,
    exports.selectBasketOutcomesLength,
    exports.selectIsNotActiveStatus,
], (errors, outcomeErrors, outcomesLength, isNotActiveStatus) => {
    const checkSingleOutcomeError = (0, values_1.default)(outcomeErrors).some((error) => error.message);
    // if we have only one outcome in basket and this outcome has status Pending or Completed, we disable make bet button
    if (outcomesLength === 1) {
        return isNotActiveStatus || !(0, isEmpty_1.default)(errors) || checkSingleOutcomeError;
    }
    return !(0, isEmpty_1.default)(errors) || checkSingleOutcomeError;
});
exports.selectDisabledButtonExpressSystem = (0, toolkit_1.createSelector)([
    exports.getMakeBetErrors,
    exports.selectDuplicateEvents,
    exports.selectIsNotActiveStatus,
    exports.getBasketDependentEventGroups,
], (errors, duplicateEvents, isNotActiveStatus, dependentEventGroups) => !(0, isEmpty_1.default)(errors) ||
    !!duplicateEvents.length ||
    isNotActiveStatus ||
    !!dependentEventGroups.length);
exports.selectDisabledButtonOrdinarNew = (0, toolkit_1.createSelector)([
    exports.selectClientErrors,
    exports.selectOrdinarOutcomeErrorMessages,
    exports.selectBasketOutcomesLength,
    exports.selectIsNotActiveStatus,
], (clientErrors, errorMessages, outcomesLength, isNotActiveStatus) => {
    const checkSingleOutcomeError = (0, values_1.default)(errorMessages).some((error) => error.message);
    // if we have only one outcome in basket and this outcome has status Pending or Completed, we disable make bet button
    if (outcomesLength === 1) {
        return (isNotActiveStatus || !(0, isEmpty_1.default)(clientErrors) || checkSingleOutcomeError);
    }
    return !(0, isEmpty_1.default)(clientErrors) || checkSingleOutcomeError;
});
/*
 Дополнительный хелпер селектор, используется для получения списка исходов в корзине (т.к после загрузки они лежат по ключам)
 В отличии от selectBasketOutcomesList, для валидации, нам не надо пересобирать отсортированный список или энричить именами игроков
*/
exports.selectBasketOutcomesListV2 = (0, toolkit_1.createSelector)([exports.selectBasketOutcomesMapEntries], (entries) => {
    return Object.values(entries);
});
exports.selectCanMakeOrdinarBet = (0, toolkit_1.createSelector)([
    exports.selectClientErrors,
    exports.selectOrdinarOutcomeErrorMessages,
    exports.selectBasketOutcomes,
    selectors_1.selectFeatureFlags,
], (clientErrors, errorMessages, outcomes, featureFlags) => {
    const hasClientErrors = !(0, isEmpty_1.default)(clientErrors);
    const hasOutcomeError = (0, values_1.default)(errorMessages).some((error) => error.message);
    if (hasClientErrors || hasOutcomeError) {
        return false;
    }
    const { EVENTS_EXCLUSION_ENABLED } = featureFlags;
    return outcomes.some((outcome) => (0, validation_1.isOutcomeAvailableToBet)(outcome, {
        checkExclusion: EVENTS_EXCLUSION_ENABLED !== null && EVENTS_EXCLUSION_ENABLED !== void 0 ? EVENTS_EXCLUSION_ENABLED : false,
    }));
});
exports.selectCanMakeComplexBet = (0, toolkit_1.createSelector)([
    exports.selectClientErrors,
    exports.getBasketDependentEventGroups,
    exports.selectBasketOutcomes,
    selectors_1.selectFeatureFlags,
], (clientErrors, dependentEventGroups, outcomes, featureFlags) => {
    const hasClientErrors = !(0, isEmpty_1.default)(clientErrors);
    const hasDependentEventGroups = dependentEventGroups.length > 0;
    if (hasClientErrors || hasDependentEventGroups) {
        return false;
    }
    const { EVENTS_EXCLUSION_ENABLED, ONLY_ORDINAR_ENABLED } = featureFlags;
    return (0, validation_1.allOutcomesAvailableForComplexBet)(outcomes, {
        checkExclusion: EVENTS_EXCLUSION_ENABLED !== null && EVENTS_EXCLUSION_ENABLED !== void 0 ? EVENTS_EXCLUSION_ENABLED : false,
        checkOnlyOrdinar: ONLY_ORDINAR_ENABLED !== null && ONLY_ORDINAR_ENABLED !== void 0 ? ONLY_ORDINAR_ENABLED : false,
    });
});
exports.selectDisabledButtonExpressSystemNew = (0, toolkit_1.createSelector)([
    exports.selectClientErrors,
    exports.selectDuplicateEvents,
    exports.selectIsNotActiveStatus,
    exports.getBasketDependentEventGroups,
], (clientErrors, duplicateEvents, isNotActiveStatus, dependentEventGroups) => !(0, isEmpty_1.default)(clientErrors) ||
    !!duplicateEvents.length ||
    isNotActiveStatus ||
    !!dependentEventGroups.length);
// TODO replace to primitive { status, id }
exports.selectIsDependentOutcomes = (0, toolkit_1.createSelector)([
    exports.getEventValue,
    exports.selectBasketBetTypeTab,
    exports.selectDuplicateEvents,
    exports.getBasketDependentEventGroups,
], ({ status, id }, BetTypeTab, duplicateEvents, dependentEventGroups) => {
    const betType = BetTypeTab !== types_2.EBetTypes.Ordinar;
    return ((betType &&
        duplicateEvents.some((eventId) => eventId === id) &&
        constants_2.activeEventStatus.includes(status)) ||
        (betType && dependentEventGroups.flat().includes(id)));
});
exports.selectIsDependedHighlightedOutcome = (0, toolkit_1.createSelector)([exports.getIsDependentOutcome, exports.getHighlightedDependentOutcomesList], (eventId, highlightedDependentOutcomesList) => highlightedDependentOutcomesList.includes(eventId));
const selectDependentEventGroupsLength = (state) => (0, exports.getBasketDependentEventGroups)(state).length;
exports.selectDependentEventGroupsLength = selectDependentEventGroupsLength;
const selectHighlightedDependentOutcomesListLength = (state) => (0, exports.getHighlightedDependentOutcomesList)(state).length;
exports.selectHighlightedDependentOutcomesListLength = selectHighlightedDependentOutcomesListLength;
exports.selectDependentEventByOutcomeId = (0, toolkit_1.createSelector)([exports.getOutcomeId, exports.selectBasketOutcomesList, exports.getBasketDependentEventGroups], (outcomeId, outcomes, basketDependentEventGroups) => {
    const outcome = outcomes.find((outcome) => outcome.id === outcomeId);
    if (outcome) {
        const isDependentEvent = basketDependentEventGroups
            .flat()
            .includes(outcome.event.id);
        return isDependentEvent;
    }
    return false;
});
const APPLIED_COUPONS_EMPTY_ARRAY = [];
exports.selectActiveLoyaltyByAppliedCouponIds = (0, toolkit_1.createSelector)([
    selectors_4.selectLoyalty,
    exports.getBasketAppliedCouponIds,
    exports.selectBasketBetTypeTab,
    exports.selectBasketOutcomesLength,
], (coupons, appliedCouponIds, currentBetTypeTab, outcomesLength) => {
    if (coupons.length === 0) {
        return APPLIED_COUPONS_EMPTY_ARRAY;
    }
    return (currentBetTypeTab === types_2.EBetTypes.Ordinar && outcomesLength > 1) ||
        currentBetTypeTab === types_2.EBetTypes.System
        ? APPLIED_COUPONS_EMPTY_ARRAY
        : coupons.filter((coupon) => coupon.status &&
            constants_1.LOYALTY_ACTIVE_STATUS.includes(coupon.status) &&
            (appliedCouponIds === null || appliedCouponIds === void 0 ? void 0 : appliedCouponIds.includes(coupon.id)));
});
const NOT_APPLIED_COUPONS_EMPTY_ARRAY = [];
exports.selectActiveLoyaltyWithoutAppliedCouponIds = (0, toolkit_1.createSelector)([
    selectors_4.selectLoyalty,
    exports.getBasketAppliedCouponIds,
    exports.selectBasketBetTypeTab,
    exports.selectBasketOutcomesLength,
], (coupons, appliedCouponIds, currentBetTypeTab, outcomesLength) => {
    if (coupons.length === 0) {
        return NOT_APPLIED_COUPONS_EMPTY_ARRAY;
    }
    return (currentBetTypeTab === types_2.EBetTypes.Ordinar && outcomesLength > 1) ||
        currentBetTypeTab === types_2.EBetTypes.System
        ? NOT_APPLIED_COUPONS_EMPTY_ARRAY
        : coupons.filter((coupon) => coupon.status &&
            constants_1.LOYALTY_ACTIVE_STATUS.includes(coupon.status) &&
            !(appliedCouponIds === null || appliedCouponIds === void 0 ? void 0 : appliedCouponIds.includes(coupon.id)));
});
exports.selectLoyaltyCouponCreatedStatus = (0, toolkit_1.createSelector)([selectors_4.selectLoyalty], (coupons) => coupons.filter((coupon) => coupon.status && constants_1.LOYALTY_ACTIVE_STATUS.includes(coupon.status)));
exports.selectActiveLoyaltyWithoutAppliedCouponIdsLength = (0, toolkit_1.createSelector)([exports.selectActiveLoyaltyWithoutAppliedCouponIds], (couponIds) => couponIds.length);
exports.selectActiveLoyaltyByAppliedCouponIdsByBetType = (0, toolkit_1.createSelector)([
    exports.getLoyaltyCouponsType,
    exports.selectLoyaltyCouponCreatedStatus,
    exports.getBasketAppliedCouponIds,
    exports.selectBasketOutcomesLength,
], (loyaltyCouponsType, coupons, appliedCouponIds, outcomesLength) => {
    const isSuitableCoupons = loyaltyCouponsType === types_1.ELoyaltyCoupons.SUITABLE;
    const [suitableLoyaltyCoupons, unsuitableLoyaltyCoupons] = (0, partition_1.default)(coupons, (coupon) => appliedCouponIds === null || appliedCouponIds === void 0 ? void 0 : appliedCouponIds.includes(coupon.id));
    const loyaltyCoupons = isSuitableCoupons
        ? suitableLoyaltyCoupons
        : unsuitableLoyaltyCoupons;
    const ordinarCoupons = outcomesLength > 1 ? (isSuitableCoupons ? [] : coupons) : loyaltyCoupons;
    const expressCoupons = loyaltyCoupons;
    const systemCoupons = isSuitableCoupons ? [] : coupons;
    return {
        [types_2.EBetTypes.Ordinar]: ordinarCoupons,
        [types_2.EBetTypes.Express]: expressCoupons,
        [types_2.EBetTypes.System]: systemCoupons,
    };
});
const selectBasketAppliedCoupon = (state) => {
    var _a;
    return (_a = state.basketProvider.basket.currentAppliedCoupon) !== null && _a !== void 0 ? _a : slice_1.initialState.basket.currentAppliedCoupon;
};
exports.selectBasketAppliedCoupon = selectBasketAppliedCoupon;
exports.selectLoyaltyCouponCreatedStatusLength = (0, toolkit_1.createSelector)([exports.selectLoyaltyCouponCreatedStatus], (coupons) => coupons.length);
// TOTO perhaps remove
exports.selectIsBasketSuitableBonusCouponsShown = (0, toolkit_1.createSelector)([
    exports.selectLoyaltyCouponCreatedStatusLength,
    exports.selectBasketBetTypeTab,
    exports.selectBasketOutcomesLength,
    exports.selectActiveLoyaltyWithoutAppliedCouponIdsLength,
], (length, currentBetTypeTab, outcomesLength, activeLoyaltyWithoutAppliedCouponIdsLength) => !!length &&
    (currentBetTypeTab === types_2.EBetTypes.Express ||
        (currentBetTypeTab === types_2.EBetTypes.Ordinar && outcomesLength === 1)) &&
    !!activeLoyaltyWithoutAppliedCouponIdsLength);
const selectAvailableAmount = (state) => {
    const balance = (0, selectors_4.selectAccountBalance)(state);
    const bonus = (0, selectors_4.selectAccountBonus)(state);
    const bonusWallet = (0, exports.selectBasketBonusWallet)(state);
    return bonusWallet ? bonus : balance;
};
exports.selectAvailableAmount = selectAvailableAmount;
exports.selectCurrentBetAmount = (0, toolkit_1.createSelector)([
    exports.selectBasketBetTypeTab,
    exports.selectOrdinarTotalAmount,
    exports.selectExpressOutcomeValue,
    exports.selectSystemAmount,
], (currentBetTypeTab, ordinarTotalAmount, expressOutcomeValue, systemAmount) => {
    return {
        [types_2.EBetTypes.Ordinar]: ordinarTotalAmount,
        [types_2.EBetTypes.Express]: expressOutcomeValue,
        [types_2.EBetTypes.System]: systemAmount,
    }[currentBetTypeTab];
});
exports.selectExpressSystemValidationErrors = (0, toolkit_1.createSelector)([exports.selectMaxBetExpressSystem, exports.selectCurrentBetAmount, selectors_2.selectCurrencyMinBet], (maxBetExpressSystem, amount, minBet) => {
    return (0, utils_1.validateBasketAmount)({
        amount: +amount,
        minValue: minBet,
        maxValue: maxBetExpressSystem,
    });
});
exports.selectBasketBalanceError = (0, toolkit_1.createSelector)([
    exports.selectAvailableAmount,
    exports.selectCurrentBetAmount,
    exports.selectBasketAppliedCoupon,
    exports.selectBasketBonusWallet,
], (availableAmount, amount, appliedCoupon, bonusWallet) => {
    const error = bonusWallet
        ? constants_2.EAllBasketErrors.BETS_INSUFFICIENT_BONUS
        : constants_2.EAllBasketErrors.BETS_INSUFFICIENT_BALANCE;
    if (+amount > availableAmount && !appliedCoupon) {
        return error;
    }
    return null;
});
exports.selectOrdinarValidationErrors = (0, toolkit_1.createSelector)([
    exports.selectCurrentBetAmount,
    selectors_2.selectCurrencyMinBet,
    exports.selectOrdinarOutcomeErrors,
    exports.selectBasketAppliedCoupon,
], (amount, minBet, ordinarOutcomeErrors, appliedCoupon) => {
    return (0, utils_1.validateOrdinar)({
        ordinarOutcomeErrors,
        minBet,
        amountTotal: +amount,
        isAppliedCoupon: !!appliedCoupon,
    });
});
exports.selectIsValidBasketInput = (0, toolkit_1.createSelector)([exports.selectClientErrors, exports.getMakeBetErrors], (clientErrors, makeBetErrors) => {
    return !(clientErrors.length || makeBetErrors.length);
});
const selectCompetitorConstraintError = (state) => {
    return state.basketProvider.competitorConstraints.rejectedEventIds.length
        ? constants_2.EAllBasketErrors.BET_COMPETITOR_CONSTRAINT_ERROR
        : null;
};
exports.selectCompetitorConstraintError = selectCompetitorConstraintError;
//# sourceMappingURL=selectors.js.map